import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import LogoJoao from "../static/logo_joao.JPG";

const Navigation = function () {
  const [menuIsShown, setMenuIsShown] = useState(false);
  const location = useLocation();
  const showMenu = function () {
    const navBar = document.querySelector("nav");
    if (menuIsShown) {
      navBar.classList.toggle("showNav");
      setMenuIsShown(false);
    } else {
      navBar.classList.toggle("showNav");
      setMenuIsShown(true);
    }
  };

  const toggleActive = function (event) {
    const li = event.currentTarget;
    const activeli = document.querySelector(".navActive");
    activeli.classList.remove("navActive");
    li.classList.add("navActive");
    const nav = document.querySelector("nav");
    if (nav.classList.contains("showNav")) {
      nav.classList.toggle("showNav");
    }
  };

  const [homeactive, sethomeactive] = useState("");
  const [presentationactive, setpresentationactive] = useState("");
  const [workareaactive, setworkareaactive] = useState("");
  const [teachingactive, setteachingactive] = useState("");
  const [contactactive, setcontactactive] = useState("");

  useEffect(() => {
    const pathname = location.pathname.substring(1);
    switch (pathname) {
      case "":
        sethomeactive("navActive");
        break;
      case "apresentacao":
        setpresentationactive("navActive");
        break;
      case "areas-actuacao":
        setworkareaactive("navActive");
        break;
      case "formacao":
        setteachingactive("navActive");
        break;
      case "contact":
        setcontactactive("navActive");
        break;
      default:
        console.log("error");
    }
  }, [location]);

  return (
    <header>
      <Link to="/">
        <div className="logo" onClick={toggleActive}>
          <img src={LogoJoao} alt="logo" />
        </div>
      </Link>
      <div className="showMenuDiv">
        Menu
        <button className="showMenu" onClick={showMenu}>
          <i className="las la-bars"></i>
        </button>
      </div>
      <nav>
        <ul>
          <li onClick={toggleActive} className={homeactive}>
            <Link to="/" onClick={toggleActive}>
              Início
            </Link>
          </li>
          <li onClick={toggleActive} className={presentationactive}>
            <Link to="/apresentacao" onClick={toggleActive}>
              Apresentação
            </Link>
          </li>
          <li onClick={toggleActive} className={workareaactive}>
            <Link to="/areas-actuacao" onClick={toggleActive}>
              Áreas de Actuação
            </Link>
          </li>
          <li onClick={toggleActive} className={teachingactive}>
            <Link to="/formacao" onClick={toggleActive}>
              Formação
            </Link>
          </li>
          <li onClick={toggleActive} className={contactactive}>
            <Link to="/contacto" onClick={toggleActive}>
              Contacto
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Navigation;
